
import { UseQueryOptions } from "react-query";
import { GeneratedQuery, AxiosError, GraphQLQuery, MapResponseFn } from "@eco/client";
import useEcoClient from "hooks/useEcoClient";
import { QueryErrorType } from "./useMonitorQuery";
import useEcoQuery, { UseEcoQueryOptions } from "./useEcoQuery";
import { useMemo } from "react";


/**
 * 
 * Custom hook to query Ecomundo graphQL API   
 * 
 * @deprecated since eco-factory "21.37". Use "useGraphqlSearch" instead.
 * @param query object containing graphql query or undefined (it can be undefined as hooks cannot be called conditionnaly)
 * @param mapResponseFn mapping function for API response
 * @param config to pass to reactQuery
 * 
 */
export const useGraphQLQuery = <TData, S extends GraphQLQuery & GeneratedQuery, R = unknown> (
    query?: S,
    mapResponseFn?: MapResponseFn<TData,R>,
    config?: UseEcoQueryOptions<unknown, TData, AxiosError>
) => 
{
    const ecoClient = useEcoClient();
    const cacheKey = useMemo(() => [query?.cacheKey, query?.variables], [query])
    
    const signedQuery = query && { 
        gql: query.gql,
        variables: query.variables,
        config: {},
    } as GraphQLQuery ;

    if (process.env.REACT_APP_SIGN_QUERY && signedQuery) {
        signedQuery.config!.headers = {
            'Authorization' : `Bearer ${query?.signature}`
        }
    }
    
    const queryFn = async () => {
        return ecoClient.search<TData,R>(signedQuery!, mapResponseFn);
    }
    // call react-query with name of the query class as cache name
    return useEcoQuery(cacheKey, queryFn, { enabled: query !== undefined, ...config})
}

export type useGraphqlQueryOptions<TQueryFnData = unknown, TError = unknown, TData = TQueryFnData> = 
    UseQueryOptions<TQueryFnData, TError, TData>
    & QueryErrorType<TError>
